module.exports = __webpack_public_path__ + "img/cart.e20a2e86.svg";